import type React from "react"

import { motion, AnimatePresence } from "framer-motion"
import { X } from "lucide-react"
import { Button } from "../Button/Button"
import { createPortal } from "react-dom"

interface DialogModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  size?: "md" | "lg" | "xl" | "2xl" | "3xl"
  actions?: React.ReactNode[]
}

export function DialogModal({ isOpen, onClose, title, children, size = "md", actions }: DialogModalProps) {
  return <>
  
    {typeof window !== 'undefined' &&createPortal(<AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={onClose}
              className="fixed inset-0   bg-surface-overlay backdrop-blur-sm bg-black/20  "
            />

            {/* Dialog */}
            <div className="fixed inset-0 flex items-center justify-center  p-4">
              <motion.div
                initial={{ opacity: 0, scale: 0.95, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95, y: 20 }}
                transition={{ type: "spring", duration: 0.3 }}
                className={`bg-surface bg-white  rounded-2xl shadow-large border border-border w-full max-w-${size} max-h-[90vh] overflow-hidden`}
              >
                {/* Header */}
                <div className="flex items-center justify-between p-3  border-b border-border">
                  <h2 className="  text-lg font-semibold text-text">{title}</h2>
                  <Button
                    size="sm"
                    onClick={onClose}

                    className="h-8 w-8 px-[6px] bg-red-700 hover:bg-red-900   "
                  >
                    <X />
                  </Button>
                </div>
                <div className="p-3 overflow-y-auto max-h-[calc(90vh-120px)]">{children}</div>

                {actions && actions.length > 0 && (
                  <div className="p-4 border-t border-primary-100 flex    flex-row justify-end  gap-2 bg-white">
                    {actions.map((action, index) => (
                      <div key={index} >{action}</div>
                    ))}
                  </div>
                )}
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>,
      document.body 
    )}
  </> 
}
  
